import type { LangComJa } from './lang-com-ja';
export const LangComEn: typeof LangComJa = {
  pageBack: 'Back',
  pageNext: 'Next',
  back: 'Back',
  close: 'Close',
  send: 'Send',
  langtoggle: '日本語',
};
